module.exports = __webpack_public_path__ + "static/media/mem_companies.697685b5.svg";